// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconPaymentsPath = 'm25.887 9.51-8.558-6.85-5.264 6.843H7.5c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h18v-12h-2.652l3.039-3.993ZM23.5 23.503h-16c-.551 0-1-.449-1-1v-7.171c.313.11.649.171 1 .171h16v8Zm-12.973-12H7.5c-.551 0-1 .449-1 1 0 .551.449 1 1 1h1.488l1.539-2Zm7.144-6.007 5.442 4.356-2.779 3.651h-8.822l6.159-8.007ZM21.5 20.503h-2v-2h2v2Z';
var NavigationIconPayments = baseIcon('NavigationIconPayments', {
  getPath: () => NavigationIconPaymentsPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconPayments;
//# sourceMappingURL=index.js.map